<template>
  <lay-layout v-user-no-select >
    <lay-header style="height: 81px;" v-show="route.path != '/login'">
      <TopBar :title="title"></TopBar>
      <FMSIndex :fms="fms" ></FMSIndex>
    </lay-header>
    <lay-body>
      <PanelArrow :toggleRight="toggleRight" @toggle="toggleRight = !toggleRight" v-if="false"></PanelArrow>
      <lay-layer type="drawer" v-model="toggleRight" :title="''" area="300px" :shadeClose="false" :shade="false" :closeBtn="false">
        <lay-field title="功能配置面板">功能配置面板</lay-field>
      </lay-layer>
      <lay-scroll :height="autoHeight" :style="{'background-color': currentViewBgColor}" thumbColor="#e2e2e2">
        <router-view />
      </lay-scroll>
    </lay-body>
  </lay-layout>
</template>

<script setup>
import TopBar from "@/components/TopBar";
import {ref, nextTick, computed, provide, watch} from "vue";
// import ControlRecord from  "@/components/ControlRecord";
// import PowerCount from "@/components/PowerCount"
// import NotFound from "@/components/NotFound"
import FMSIndex from "@/components/FMSIndex";
import {useSize} from "@/assets/js/size";
import PanelArrow from "@/components/utils/PanelArrow";
import {useClock} from "@/assets/js/clock";
import {useUpdateService} from "@/assets/js/updateService";
import {useRoute} from "vue-router/dist/vue-router";

const {seconds} = useClock();
const  currentViewBgColor = ref("#09141F");
const route = useRoute();
const {APP_VERSION} = useUpdateService();

watch(() => route.path, (newValue) =>{
  currentViewBgColor.value = bgColor[newValue];

})

const toggleRight = ref(false);

provide("seconds", seconds);


const title = ref('青岛青春足球场数据监控后台系统V' + APP_VERSION)
const fms = [
    {title: "1ES系统图", hash: "/1", avatar: "layui-icon-picture"},
    {title: "2ES系统图", hash: "/2", avatar: "layui-icon-picture"},
    {title: "3ES系统图", hash: "/3", avatar: "layui-icon-picture"},
    {title: "4ES系统图", hash: "/4", avatar: "layui-icon-picture"},

  // {title: "用电统计", hash: "#/3", avatar: "layui-icon-table"},
  // {title: "遥控记录", hash: "#/", avatar: "layui-icon-time"},
  // {title: "视频监控", hash: "#/6", avatar: "layui-icon-video"},
  {title: "数据监控", hash: "/7", avatar: "layui-icon-chart-screen"},
  {title: "事件记录", hash: "/9", avatar: "layui-icon-notice"},
  {title: "用电统计", hash: "/8", avatar: "layui-icon-table"},


  // {title: "需量分析", hash: "#/8", avatar: "layui-icon-chart"},
  // {title: "运行状态", hash: "#/18", avatar: "layui-icon-set-sm"}
]

const {height} = useSize();


const bgColor = {
  "/1": '#09141F',
  "/2": '#09141F',
  "/3": '#09141F',
  "/4": '#09141F',
  "/9": 'whitesmoke',
  "/7": 'whitesmoke',
  "/8": 'whitesmoke',
  "/login": 'whitesmoke'
}



const autoHeight = computed(() => {
  return (height.value - 81) + "px";
});

const target = ref()
nextTick(()=>{
  target.value=document.querySelector(".layui-body");
})


</script>

<style>

#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}
.layui-tab-brief>.layui-tab-head>.layui-tab-title > .layui-this{
  color: #1e9fff !important;
}
.layui-tab-active-bar{
  background-color: #1e9fff !important;
}
.layui-body{
  min-height: 0 !important;
}
.layui-footer{
  line-height: 40px;
}
/*.layui-tab-content{*/
/*  display: none;*/
/*}*/
@keyframes fade{
  from {
    opacity: 1.0;
  }
  50%{
    opacity: 0.5;
  }
  to{
    opacity: 1.0;
  }
}
@-webkit-keyframes fade {
  from {
    opacity: 1.0;
  }
  50%{
    opacity: 0.5;
  }
  to{
    opacity: 1.0;
  }
}
.bling{
  animation: fade 800ms infinite;
  -webkit-animation: fade 800ms infinite;
}



</style>
